// Hamburger Animation
$(".hamburger").click(function () {
    $(this).toggleClass("is-active");
});

$(".js-nav-control").click(function () {
    $('body').toggleClass('open');
});

// MATCH HEIGHT
// -- sections/component-featured-products
$(function() {$('.featured-product').matchHeight();})
// -- sections/component-product-carousel
$(function() {$('.product-carousel-item').matchHeight();})

$(window).scroll(function () {
    var $this = $(this),
        $head = $('header');
    if ($this.scrollTop() > 120) {
        $head.addClass('bottom-announcement-deactivated');
    } else {
        $head.removeClass('bottom-announcement-deactivated');
    }
});

// Smooth Scroll Animation


// SEARCH
// $('.user-icons').on("click", function (e) {
//     $('#search-pop').hide();
// });

// SEARCH TOGGLE
var $searchActive = false;
$("body").on("click", '.js-show-search, .search-close', function (e) {
	if ( !$('.secret-search').hasClass('activated-search') ) {
		$searchActive = true;
        $('.js-show-search').attr("aria-expanded","true");
	}
    $('.nav-level-1-link').parent('li').toggleClass('hide-this-nav-link').toggleClass('hoverable');
    $('.secret-search').toggleClass('activated-search').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
});

// SEARCH: DiSABLE button unless not blank
$(document).ready(function() {
    $('#secrett').on('keyup', function() {
      var empty = false;
      $('#secrett').each(function() {
        empty = $(this).val().length == 0;
      });
      if (empty) { $('#secret-search button').attr('disabled', 'disabled'); }
      else { $('#secret-search button').attr('disabled', false); }
    });
});

$("body").on("click", '.js-show-mobile-search, .search-close', function (e) {
    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
    if ($('#search-pop').is(":visible") && $(window).scrollTop() == 0) {
        $(".index .header").removeClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
        $(".index .header").addClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }
    $('#search-pop').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
});

// COMPONENT-FEATURED-PRODUCTS
$('.js-featured-products').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    arrows: true,
    lazyLoad: 'ondemand',
    prevArrow: `<a href='#' class='slick-arrow slick-prev'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M0.979942 3.64645C0.78468 3.84171 0.78468 4.15829 0.979942 4.35355L4.16192 7.53553C4.35719 7.7308 4.67377 7.7308 4.86903 7.53553C5.06429 7.34027 5.06429 7.02369 4.86903 6.82843L2.0406 4L4.86903 1.17157C5.06429 0.976311 5.06429 0.659728 4.86903 0.464466C4.67377 0.269204 4.35719 0.269204 4.16192 0.464466L0.979942 3.64645ZM12 3.5L1.3335 3.5V4.5L12 4.5V3.5Z" fill="black"/></svg></a>`,
    nextArrow: `<a href='#' class='slick-arrow slick-next'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M11.3536 4.35356C11.5488 4.15829 11.5488 3.84171 11.3536 3.64645L8.17157 0.464467C7.97631 0.269205 7.65973 0.269205 7.46447 0.464467C7.2692 0.65973 7.2692 0.976312 7.46447 1.17157L10.2929 4L7.46447 6.82843C7.2692 7.02369 7.2692 7.34027 7.46447 7.53554C7.65973 7.7308 7.97631 7.7308 8.17157 7.53554L11.3536 4.35356ZM0.333496 4.5L11 4.5L11 3.5L0.333496 3.5L0.333496 4.5Z" fill="black"/></svg></a>`,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                arrows: true,
                slidesToScroll: 1,
            }
        }
    ]
});

$('.js-blog-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 600,
            centerMode: true,
            centerPadding: '60px',
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
            }
        }
    ]
});

function pdp_carousel() {

  // PDP CAROUSEL WITH THUMBS
  $('.js-slider-primary').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      infinite: true,
      lazyLoad: 'ondemand',
      arrows:false,
      asNavFor: '.js-slider-thumbs',
      responsive: [{
      breakpoint: 768,
          settings: {
              arrows: true,
              nextArrow:"<button style='padding-left:10px;' type='button' class='slick-next pull-right'> <svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M11.354 4.3599C11.5493 4.16464 11.5493 3.84806 11.354 3.6528L8.17206 0.470815C7.9768 0.275553 7.66022 0.275553 7.46495 0.470815C7.26969 0.666077 7.26969 0.98266 7.46495 1.17792L10.2934 4.00635L7.46495 6.83478C7.26969 7.03004 7.26969 7.34662 7.46495 7.54188C7.66022 7.73715 7.9768 7.73715 8.17206 7.54188L11.354 4.3599ZM0.333984 4.50635L11.0005 4.50635L11.0005 3.50635L0.333984 3.50635L0.333984 4.50635Z' fill='black'/></svg></button>",
              prevArrow:"<button style='padding-right:10px;' type='button' class='slick-prev pull-left'><svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M0.979942 3.65279C0.78468 3.84806 0.78468 4.16464 0.979942 4.3599L4.16192 7.54188C4.35719 7.73714 4.67377 7.73714 4.86903 7.54188C5.06429 7.34662 5.06429 7.03004 4.86903 6.83477L2.0406 4.00635L4.86903 1.17792C5.06429 0.982658 5.06429 0.666076 4.86903 0.470814C4.67377 0.275552 4.35719 0.275552 4.16192 0.470814L0.979942 3.65279ZM12 3.50635L1.3335 3.50635V4.50635L12 4.50635V3.50635Z' fill='black'/></svg></button>"
          }
      }]
  });
  $('.js-slider-thumbs').slick({
      slidesToShow: 4,
  	slidesToScroll: 4,
  	asNavFor: '.js-slider-primary',
  	dots: false,
  	//adaptiveHeight: true,
  	centerMode: false,
  	cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  	vertical:true,
  	focusOnSelect: true,
  	useTransform:true,
  	infinite:false,
  	//variableWidth: true,
  	arrows: true,
      nextArrow:"<button type='button' class='slick-prev pull-left' ><svg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'><path d='M11 21.883l-6.235-7.527-.765.644 7.521 9 7.479-9-.764-.645-6.236 7.529v-21.884h-1v21.883z'/></svg></button>",
      prevArrow:"<button type='button' class='slick-prev pull-left' ><svg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'><path d='M11 2.206l-6.235 7.528-.765-.645 7.521-9 7.479 9-.764.646-6.236-7.53v21.884h-1v-21.883z'/></button>",
  	responsive: [
          {
              breakpoint: 767,
              settings: {
  	            slidesToShow: 4,
  	            arrows: false,
                  nextArrow:"<button type='button' class='slick-prev pull-left' ><svg style='rotate: -90deg' width='24' height=24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'><path d='M11 21.883l-6.235-7.527-.765.644 7.521 9 7.479-9-.764-.645-6.236 7.529v-21.884h-1v21.883z'/></svg></button>",
                  prevArrow:"<button type='button' class='slick-prev pull-left' ><svg style='rotate: -90deg' width='24' height=24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd'><path d='M11 2.206l-6.235 7.528-.765-.645 7.521-9 7.479 9-.764.646-6.236-7.53v21.884h-1v-21.883z'/></button>",
  	            vertical:false,
  	            adaptiveHeight: false,
  	            useTransform:false,
                focusOnSelect: true,
                variableWidth: true,
               /* autoplay: true,
                autoplaySpeed: 2000,
                speed: 2000,*/
  	            slidesToScroll: 4,
                centerMode: false
              }
  	    }
      ]
  });
}
//pdp_carousel();
document.addEventListener("PDPCarousel",event=>pdp_carousel());


// CHANGE IMAGE WITH VARIANT CHANGE
(function (window, $) {
    $(document).ready(function () {
        $('body')
            .on('change', '#productSelect', function (event) {
                // Update Price
                var selected = this.options[this.selectedIndex],
                    variantPrice = selected.dataset.price;
                $('#productPrice').text(variantPrice);
                /** Update image Slider */
                var variantImage = selected.dataset.image;
                var position = -1;
                $('.product-thumbs .single-thumb').each(function () {
                    if ($(this).data('image') == variantImage) {
                        position = parseInt($(this).data('slick-index'));
                        return;
                    }
                });
                if (position != -1) {
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
                }
                /** Update Nutritions table tab content */
                if (this.options.length > 1 && window.product_variants !== undefined) {
                    product_variants.forEach((variant_meta) => {
                        if (variant_meta.id == selected.value) {
                            for (const [key, value] of Object.entries(variant_meta)) {
                                $(`.js-meta-${key}`).empty().html(value);
                            }
                        }
                    });
                }
            })
    })
})(window, jQuery);

// Footer Nav
function resizeHandler() {
    console.log("window resized");
    if ($(window).width() < 767) {
        console.log("window small than 600");
        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}
resizeHandler();
$(window).resize(resizeHandler);

$(document).ready(function () {
if ($(window).width() < 767) {
    document.querySelectorAll(".footer-nav-header").forEach(item=>{
      item.addEventListener("click",event=>{
        let old = document.querySelector(".footer-nav-header.expanded");
        if (old && old!=item) {
          old.classList.remove("expanded");
          $(old).next().slideToggle(200);
        }
        $(item).next().slideToggle(200);
        $(item).toggleClass("expanded");
      });
    });

    $('.footer-nav ul').slideUp(200);
}
});
/*
$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 767) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});
*/

var yourNavigation = $("#shopify-section-header");
    stickyDiv = "sticky";
    yourHeader = $('header').height();

$(window).scroll(function() {
  if( $(this).scrollTop() > yourHeader ) {
    yourNavigation.addClass(stickyDiv);
  } else {
    yourNavigation.removeClass(stickyDiv);
  }
});

// document.getElementById('js-variant-selector').addEventListener('change', function() {
//     const variantId = this.value;
//     const variant = product.variants.find(v => v.id == variantId);

//     const imagesContainer = document.getElementById('variant-images');
//     imagesContainer.innerHTML = '';

//     variant.featured_image.forEach(function(image) {
//         const img = document.createElement('img');
//         img.src = "//www.surrattbeauty.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif";
//         img.alt = "";
//         imagesContainer.appendChild(img);
//     });
// });

$('.active-variant label').click(function(){
    $(this).parent().parent().parent().parent().toggleClass('selecting');
});
$('.js-variant-selector li:not(.active-variant) input').on('change', function(){
    var $varID = $(this).attr("[data-variant-id");
    var $productID = $(this).attr("[data-product-id");
    $(this).parent().siblings('.active-variant').removeClass('active-variant');
    $(this).parent().toggleClass('active-variant');
    $(this).parent().parent().parent().parent().removeClass('selecting');
    $('#'+$productID+' .selected-image').hide().removeClass('selected-image');
    $('#'+$productID).find('img').each(function( index ) {
        if ( $(this).attr("[data-variant-id]") == $varID ) {
            $(this).toggle;
        }
    });
});

// sections/component-image-text
// sections/pdp-faq
$(document).ready(function() {
	$('.js-tab-content').hide();
	$('.js-tab-content').slideUp(200);
	$('body').on('click', '.js-tab-heading', function () {
		var container = $(this).parents('section').attr('id');
		if (!$(this).hasClass('expanded')) {
			$('#'+container+' .expanded').next().slideToggle(200);
			$('#'+container+' .expanded').toggleClass('expanded');
		}
		$(this).next().slideToggle(200);
		$(this).toggleClass("expanded");
	});
});
